import { Controller } from "@hotwired/stimulus"

// Lazy loads Instagram embed.js when the element becomes visible
export default class extends Controller {
  static values = {
    loaded: { type: Boolean, default: false }
  }

  connect() {
    this.setupIntersectionObserver()
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
    }
  }

  setupIntersectionObserver() {
    // Load when element is within 200px of viewport
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !this.loadedValue) {
            this.loadInstagramEmbed()
          }
        })
      },
      { rootMargin: '200px' }
    )

    this.observer.observe(this.element)
  }

  loadInstagramEmbed() {
    if (this.loadedValue) return
    this.loadedValue = true

    // Check if script already exists
    if (document.querySelector('script[src*="instagram.com/embed.js"]')) {
      this.processEmbeds()
      return
    }

    const script = document.createElement('script')
    script.src = '//www.instagram.com/embed.js'
    script.async = true
    script.onload = () => this.processEmbeds()
    document.body.appendChild(script)

    // Disconnect observer since we've loaded
    if (this.observer) {
      this.observer.disconnect()
    }
  }

  processEmbeds() {
    // Instagram's embed.js exposes instgrm.Embeds.process() to process new embeds
    if (window.instgrm && window.instgrm.Embeds) {
      window.instgrm.Embeds.process()
    }
  }
}
